import util from './utils';

/**
 * 统一的登录检查和执行函数
 * @param {Function} action - 需要执行的操作函数
 * @param {Object} options - 配置选项
 * @param {boolean} options.showAlert - 是否显示未登录提示
 * @param {string} options.returnUrl - 自定义返回URL
 * @returns {boolean} - 是否成功执行
 */
export const checkLoginAndExecute = (action, options = {}) => {
    const { showAlert = false, returnUrl } = options;
    const clientId = util.getCurrentClientId();
    
    console.log('🔥 统一登录检查，环境:', clientId);
    
    if (clientId === 'client-a') {
        // a环境：确保用户信息存在并直接执行操作
        util.ensureUserInfo();
        console.log('🔥 a环境：直接执行操作');
        
        if (typeof action === 'function') {
            try {
                action();
                return true;
            } catch (error) {
                console.error('a环境操作执行失败:', error);
                return false;
            }
        }
        return true;
    } else {
        // b环境：检查登录状态
        console.log('🔥 b环境：检查登录状态');
        
        if (!util.isUserLoggedIn()) {
            console.log('🔥 b环境：用户未登录，跳转登录页');
            
            if (showAlert) {
                alert('请先登录后再进行此操作');
            }
            
            const currentUrl = returnUrl || window.location.href;
            const loginUrl = `${window.location.origin}/login?returnUrl=${encodeURIComponent(currentUrl)}`;
            window.location.href = loginUrl;
            return false;
        }
        
        console.log('🔥 b环境：用户已登录，执行操作');
        
        if (typeof action === 'function') {
            try {
                action();
                return true;
            } catch (error) {
                console.error('b环境操作执行失败:', error);
                return false;
            }
        }
        return true;
    }
};

/**
 * 检查是否需要显示登录相关UI元素
 * @returns {boolean} - 是否应该显示
 */
export const shouldShowLoginUI = () => {
    const clientId = util.getCurrentClientId();
    
    if (clientId === 'client-a') {
        // a环境：总是显示（因为总是"已登录"状态）
        return true;
    } else {
        // b环境：根据实际登录状态显示
        return util.isUserLoggedIn();
    }
};

/**
 * 检查是否应该显示登录按钮
 * @returns {boolean} - 是否应该显示登录按钮
 */
export const shouldShowLoginButton = () => {
    const clientId = util.getCurrentClientId();
    
    if (clientId === 'client-a') {
        // a环境：不显示登录按钮
        return false;
    } else {
        // b环境：未登录时显示登录按钮
        return !util.isUserLoggedIn();
    }
};

/**
 * 获取当前用户状态信息
 * @returns {Object} - 用户状态信息
 */
export const getUserStatus = () => {
    const clientId = util.getCurrentClientId();
    const isLoggedIn = clientId === 'client-a' ? true : util.isUserLoggedIn();
    const userId = isLoggedIn ? util.getUserId() : null;
    
    return {
        clientId,
        isLoggedIn,
        userId,
        isClientA: clientId === 'client-a',
        isClientB: clientId === 'client-b'
    };
};

export default {
    checkLoginAndExecute,
    shouldShowLoginUI,
    shouldShowLoginButton,
    getUserStatus
};